import {
    Box,
    Button,
    Header,
    Table,
    TextFilter,
} from '@amzn/awsui-components-react-v3';
import { sessionTableColumns } from './SessionTableColumns';
import { useCollection } from '@amzn/awsui-collection-hooks';
import { FilteredSession } from './ActivityGroupDeliveryDetails';

function EmptyState({
    title,
    subtitle,
    action,
}: {
    title: string;
    subtitle?: string;
    action?: React.ReactNode;
}) {
    return (
        <Box textAlign="center" color="inherit">
            <Box variant="strong" textAlign="center" color="inherit">
                {title}
            </Box>
            <Box variant="p" padding={{ bottom: 's' }} color="inherit">
                {subtitle}
            </Box>
            {action && action}
        </Box>
    );
}

export const ActivityGroupDeliveryDetailsSessionTable = ({
    filteredSessions,
}: {
    filteredSessions: FilteredSession[];
}) => {
    const { items, actions, filteredItemsCount, collectionProps, filterProps } =
        useCollection(filteredSessions, {
            filtering: {
                empty: (
                    <EmptyState title="No sessions found for the selected week." />
                ),
                noMatch: (
                    <EmptyState
                        title="No matches"
                        action={
                            <Button onClick={() => actions.setFiltering('')}>
                                Clear filter
                            </Button>
                        }
                    />
                ),
            },
            sorting: {
                defaultState: { sortingColumn: sessionTableColumns[0] },
            },
            selection: {},
        });

    return (
        <Table
            {...collectionProps}
            resizableColumns
            columnDefinitions={sessionTableColumns}
            items={items}
            header={
                <Header variant="h2" counter={`(${filteredSessions.length})`}>
                    Sessions
                </Header>
            }
            filter={
                filteredSessions.length && (
                    <TextFilter
                        {...filterProps}
                        countText={`${filteredItemsCount}  matches`}
                    />
                )
            }
        />
    );
};
